import React from 'react';
import R from 'ramda';
import { Attribute } from '~/models/utils';
import { capitalize } from '~/utils';
import { ColumnTree } from '../hooks/useTable/defineColumns';
import { FormattedMessage } from 'react-intl';

export const AttributesColumn = ColumnTree.defineNode(
  'attribute',
  ({ solution }) => {
    const attributes = R.pathOr([], ['attributes'], solution) as Attribute[];
    if (!attributes.length) return [];

    return {
      title: (
        <FormattedMessage
          id="marketplace-table-heading-attributes"
          description="Table heading, attributes"
          defaultMessage="Attributes"
        />
      ),
      children: [
        {
          title: '',
          key: 'attributes',
          className: 'col-attributes',
          render: (_, record) => {
            if (record?.attributes) {
              return Object.keys(record.attributes)
                .sort()
                .map(k => (
                  <div key={k} className="td-content">
                    <span className="tiny-label">{capitalize(k)}</span>
                    {R.pathOr('', ['attributes', k, 0, 'name'], record)}
                  </div>
                ));
            }
            return [];
          },
        },
      ],
    };
  }
);
